import { Component } from '@angular/core';

@Component({
  selector: 'app-page-not-found-page',
  imports: [],
  templateUrl: './page-not-found-page.component.html',
  styleUrl: './page-not-found-page.component.scss',
  standalone: true
})
export class PageNotFoundPageComponent {

}
